module.exports = __webpack_public_path__ + "img/sf_steps.f7586774.jpg";